<template>
    <div>车辆详情</div>
</template>
<script>
export default {
    data() {
        return {};
    }
};
</script>
